import { IconButton, Stack, SxProps, Typography } from '@mui/material'
import { C1DrawerInner } from 'components/core/drawer/C1DrawerInner'
import { C1Icon } from 'components/core/icons/C1Icon'
import { X } from 'lucide-react'
import { FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { GrantFeed, GrantFeedColumns, GrantFeedSearchFilter } from './GrantFeed'

type AppEntitlementGrantFeedDrawerProps = {
    filter: GrantFeedSearchFilter
    columns?: GrantFeedColumns[]
    canClose: (canClose: boolean) => void
    close: () => void
}

export const GrantFeedDrawerPageHeaderHeight = '60px'
const GrantFeedPageHeaderSx: SxProps = {
    backgroundColor: 'background.default',
    borderBottom: '1px solid',
    borderBottomColor: 'divider',
    px: 5,
    minHeight: GrantFeedDrawerPageHeaderHeight,
    maxHeight: GrantFeedDrawerPageHeaderHeight,
}

export const GrantFeedDrawer: FC<AppEntitlementGrantFeedDrawerProps> = ({
    filter,
    columns,
    close,
}) => {
    const intl = useIntl()

    return <C1DrawerInner>
        <Stack
            spacing={1}
            direction="row"
            justifyContent="space-between"
            flex={1}
            alignItems="center"
            sx={GrantFeedPageHeaderSx}
        >
            <Typography variant="h2" component="div">
                <FormattedMessage defaultMessage="Grant feed" id="components_grant_feed_drawer_title" />
            </Typography>
            <IconButton onClick={close} aria-label={intl.formatMessage({ id: 'component_grant_feed_drawer_close', defaultMessage: 'Close' })}>
                <C1Icon icon={X} />
            </IconButton>
        </Stack>
        <C1DrawerInner.Content>
            <GrantFeed filter={filter} columns={columns} />
        </C1DrawerInner.Content>
    </C1DrawerInner>
}
